// import { Box, Button, Typography, Modal, Grid } from "@mui/material";

import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  DialogTitle,
  Tabs,
  Tab,
  Switch,
  FormGroup,
  Typography,
  Divider,
  DialogContent,
  DialogActions,
  IconButton,
  InputAdornment,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

// import {
//   addEmployee,
//   getNewSubscriptionReachageDetails,
//   updateEmployee,
// } from "./appoinmentDashboardApi";
import { payloadDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
// import { getDataRechageDetail } from "./smbAccountRechargeCustomApiHandler";
// import { getMonthDifference } from "./smbAccounrReachargeDateFunction";
import CloseIcon from "@mui/icons-material/Close";
import { getAlldetailSerice } from "../services/servicesListApi";

// import "./test.css";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { validationPersonalInfo } from "../payment/validation";
import Swal from "sweetalert2";
import { ModalHeader } from "../../common/modalHeader";
// import { getAlldetailSerice } from "../services/servicesListApi";
import calendar from "../../assets/icon/calendarblack.png";
import { courseAdd, courseUpdate, getAllCourses } from "./instituteApi";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function AddCourseModal({
  open,
  setOpen,
  modalData,
  getCourses,
  id,
}) {
  const struct = {
    instituteId: id,
    fromDate: "",
    toDate: "",
    courseCode: "",
    courseName: "",
    courseDuration: "",
    courseStartDate: null,
    courseSummary: "",
    courseDescription: "",
    courseEligibility: "",
    contactPersonName: "",
    contactPersonMobile: "",
    whatsappNumber: "",
    emailId: "",
    fees: 0,
    installmentAvailable: true,
    lectureMode: true,
    courseTiming: "",
    courseCity: "",
    area: "",
    address: "",
    internshipProvided: true,
    status: "",
    offlineLecture: true,
    onlineLecture: true,
  };
  const info = useSelector((state) => state.reducer.detail);
  const [formData, setFormData] = useState({ ...struct });
  const [SelectedStartDate, setSelectedStartDate] = useState(null);
  const [SelectedEndDate, setSelectedEndDate] = useState(null);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const onClose = () => {
    setOpen(false);
    setTabValue("");
  };
  const [dateValue, setDateValue] = useState();
  const [dateValuet, setDateValuet] = useState();

  const [timeValue, setTimeValue] = useState(dayjs());
  const numberFields = ["fees"];
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (numberFields.includes(name)) {
      setFormData((prev) => ({
        ...prev,
        [name]: value === "" ? 0 : Number(value),
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const gender = (e) => {
    setFormData((prev) => {
      let temp = { ...prev };
      if (e.target) {
        temp.gender = e.target.value;
      } else {
        temp.gender = e;
      }
      return { ...temp };
    });
  };
  const datePickerOnChange = (newValue) => {
    setSelectedStartDate(newValue);

    setFormData((prev) => ({
      ...prev,
      fromDate: newValue
        ? dayjs(newValue).utc().format("YYYY-MM-DDTHH:mm:ss")
        : null,
    }));

    setStartDateOpen(false);
    setEndDateOpen(true);
  };

  const datePickerOnChangeEnd = (newValue) => {
    setSelectedEndDate(newValue);

    setFormData((prev) => ({
      ...prev,
      toDate: newValue
        ? dayjs(newValue).utc().format("YYYY-MM-DDTHH:mm:ss")
        : null,
    }));

    setEndDateOpen(false);
  };

  useEffect(() => {
    if (open === true && modalData) {
      console.log("modalData", modalData);
      setFormData({
        ...modalData,
        courseStartDate: modalData.courseStartDate
          ? dayjs(modalData.courseStartDate)
          : null,

        // id: modalData?.id,
      });
      setSelectedStartDate(
        modalData.fromDate ? dayjs(modalData.fromDate) : null,
      );
      setSelectedEndDate(modalData.toDate ? dayjs(modalData.toDate) : null);

      // setDateValuet()
      // getDataRechageDetail(getNewSubscriptionReachageDetails, setSubscription);
    } else {
      setFormData({ ...struct });
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    }

    // setstartDateFormat(dayjs("2024-12-12T00:00:00"));
  }, [open, modalData]);

  const [tabVale, setTabValue] = useState("");
  const tabFn = (e) => {
    setTabValue(e.target.value);
  };

  const validateJobPost = (data) => {
    if (!data.fromDate) {
      return { status: false, message: "Start date is required" };
    }

    if (!data.toDate) {
      return { status: false, message: "End date is required" };
    }

    if (dayjs(data.fromDate).isAfter(dayjs(data.toDate))) {
      return { status: false, message: "Start date must be before end date" };
    }

    if (!data.courseCode?.trim()) {
      return { status: false, message: "Course Code is required" };
    }
    if (!data.courseName?.trim()) {
      return { status: false, message: "Course Name is required" };
    }
    if (data.courseDuration <= 0) {
      return {
        status: false,
        message: "Course Duration must be greater than 0",
      };
    }

    if (!data.courseStartDate) {
      return { status: false, message: "Start date is required" };
    }

    if (!data.courseSummary) {
      return { status: false, message: "Course Summary is required" };
    }
    if (!data.courseDescription) {
      return { status: false, message: "Course Description is required" };
    }
    if (!data.contactPersonName) {
      return { status: false, message: "Contact Person Name is required" };
    }
    if (!data.contactPersonMobile) {
      return { status: false, message: "Contact Person Mobile is required" };
    }
      if (!data.emailId) {
        return { status: false, message: "Email is required" };
      }
    // .

    return { status: true };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    const validation = validateJobPost(payload);

    if (!validation.status) {
      Swal.fire({
        text: validation.message,
        icon: "warning",
        ...swalAlertPopProps,
      });
      return;
    }

    if (modalData?.id) {
      // UPDATE
      payload.id = modalData.id;
      courseUpdate(payload, () => {
        getCourses();

        setOpen(false);
      });
    } else {
      // ADD
      courseAdd(payload, () => {
        getCourses();

        setOpen(false);
      });
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const infoD = useSelector((state) => state.reducer.detail);

  useEffect(() => {
    console.log("tabValetabVale ", tabVale);
  }, [tabVale]);
  return (
    <Modal
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth="xs"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "80%", md: "70%", lg: "60%" },
          overflowY: "auto",
          height: { xs: "80vh", sm: "70vh", md: "72vh", lg: "75vh" },
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "15%", md: "20%", lg: "20%" },
          top: "10%",
        }}
      >
        <ModalHeader  title={modalData?.id ? "Edit Course Post" : "Add Course Post"} onClose={onClose} />
        {/* <DialogTitle
          color="primary"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "auto",
            p: "0px 10px !important",
          }}
        >
          Employee Information{" "}
          <CloseIcon
            sx={{ float: "right", cursor: "pointer" }}
            onClick={() => setOpen(false)}
          />
        </DialogTitle> */}

        <DialogContent sx={{ p: 2, mt: 2 }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2} sx={{ pt: 1 }} alignItems="center">
              {modalData?.id && (
                <Grid item xs={12} sm={6}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 500, color: "#01008B" }}
                    >
                      Post Status
                    </Typography>
                    <Switch
                      checked={formData.status === "active"}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          status: e.target.checked ? "active" : "inactive",
                        }));
                      }}
                    />
                  </Box>
                </Grid>
              )}
              <Grid item xs={12} sm={!modalData?.id ? 6 : 12}>
                <TextField
                  label="Post Date"
                  size="small"
                  value={
                    SelectedStartDate && SelectedEndDate
                      ? `${SelectedStartDate.format(
                          "DD-MM-YYYY",
                        )} to ${SelectedEndDate.format("DD-MM-YYYY")}`
                      : SelectedStartDate
                        ? `${SelectedStartDate.format("DD-MM-YYYY")}`
                        : ""
                  }
                  id="datepickerfield"
                  placeholder="Select date range"
                  InputProps={{
                    // sx: {
                    //   color: "#545454",
                    //   fontWeight: 400,
                    //   paddingX: "7px",
                    // },
                    readOnly: true,
                    endAdornment: (
                      <CalendarMonthIcon
                        sx={{
                          cursor: "pointer",
                          mr: 1,
                        }}
                        onClick={() => setStartDateOpen(true)} // trigger open
                      />
                    ),
                    sx: {
                      background: "#fff",
                      borderRadius: 1,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      cursor: "pointer",
                      fontFamily: "'Montserrat', sans-serif",
                      fontWeight: 500,
                    },
                  }}
                  InputLabelProps={{
                    className: "mulish",
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  onClick={() => setStartDateOpen(true)} // trigger open
                  sx={{ width: "100%" }}
                />

                <Box sx={{ position: "relative" }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      open={startDateOpen}
                      onOpen={() => setStartDateOpen(true)}
                      onClose={() => setStartDateOpen(false)}
                      value={SelectedStartDate}
                      onChange={(val) => {
                        datePickerOnChange(val);
                      }}
                      maxDate={SelectedEndDate || undefined}
                      slotProps={{
                        popper: {
                          placement: "bottom-end",
                          anchorEl: document.querySelector("#datepickerfield"),
                          sx: { zIndex: 1500 },
                        },
                        textField: { style: { display: "none" } },
                      }}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      open={endDateOpen}
                      onOpen={() => setEndDateOpen(true)}
                      onClose={() => setEndDateOpen(false)}
                      value={SelectedEndDate}
                      onChange={(val) => {
                        datePickerOnChangeEnd(val);
                      }}
                      minDate={SelectedStartDate || undefined}
                      slotProps={{
                        popper: {
                          placement: "bottom-start",
                          anchorEl: document.querySelector("#datepickerfield"),
                          sx: { zIndex: 1500 },
                        },
                        textField: { style: { display: "none" } },
                      }}
                    />
                  </LocalizationProvider>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Course Code <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="courseCode"
                    size="small"
                    value={formData.courseCode}
                    // onInput={(e) =>
                    //   (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                    //     c.toUpperCase(),
                    //   ))
                    // }
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Course Name <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="courseName"
                    size="small"
                    value={formData.courseName}
                    // onInput={(e) =>
                    //   (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                    //     c.toUpperCase(),
                    //   ))
                    // }
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={2}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 500, color: "#01008B" }}
                  >
                    Course Duration
                  </Typography>

                  <TextField
                    label="Months"
                    name="courseDuration"
                    size="small"
                    value={formData.courseDuration}
                    // onInput={(e) => {
                    //   let inputValue = e.target.value.replace(/\D/g, "");
                    //   inputValue = inputValue.slice(0, 10);
                    //   e.target.value = inputValue;
                    // }}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Course Start Date"
                      value={formData?.courseStartDate}
                      onChange={(newValue) => {
                        setFormData((prev) => ({
                          ...prev,
                          courseStartDate: newValue,
                        }));
                      }}
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          InputLabelProps: {
                            className: "mulish",
                            sx: {
                              color: "#545454",
                              fontWeight: 400,
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "15px",
                              },
                              paddingX: "7px",
                            },
                          },
                          InputProps: {
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton edge="end">
                                  <Box
                                    component="img"
                                    src={calendar}
                                    alt="calendar icon"
                                    sx={{
                                      width: 20,
                                      height: 20,
                                      cursor: "pointer",
                                    }}
                                  />
                                </IconButton>
                              </InputAdornment>
                            ),
                            classes: { input: "mulish" },
                            sx: {
                              color: "#545454",
                              fontWeight: 400,
                              fontSize: {
                                xs: "12px",
                                sm: "13px",
                                md: "15px",
                              },
                              paddingX: "7px",
                            },
                          },
                          error: false,
                        },
                      }}
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Course Summary <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="courseSummary"
                    size="small"
                    value={formData.courseSummary}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    // onInput={(e) =>
                    //   (e.target.value = e.target.value.replace(/^\w/, (c) =>
                    //     c.toUpperCase(),
                    //   ))
                    // }
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Course Description{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="courseDescription"
                    size="small"
                    value={formData.courseDescription}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    // onInput={(e) =>
                    //   (e.target.value = e.target.value.replace(/^\w/, (c) =>
                    //     c.toUpperCase(),
                    //   ))
                    // }
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Course Eligibility{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="courseEligibility"
                    size="small"
                    value={formData.courseEligibility}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    // onInput={(e) =>
                    //   (e.target.value = e.target.value.replace(/^\w/, (c) =>
                    //     c.toUpperCase(),
                    //   ))
                    // }
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Contact Person Name{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="contactPersonName"
                    size="small"
                    value={formData.contactPersonName}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/^\w/, (c) =>
                        c.toUpperCase(),
                      ))
                    }
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <TextField
                    label="Contact Person Number :"
                    name="contactPersonMobile"
                    size="small"
                    value={formData.contactPersonMobile}
                    onInput={(e) => {
                      let inputValue = e.target.value.replace(/\D/g, "");
                      inputValue = inputValue.slice(0, 10);
                      e.target.value = inputValue;
                    }}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <TextField
                    label="Whatsapp Number :"
                    name="whatsappNumber"
                    size="small"
                    value={formData.whatsappNumber}
                    onInput={(e) => {
                      let inputValue = e.target.value.replace(/\D/g, "");
                      inputValue = inputValue.slice(0, 10);
                      e.target.value = inputValue;
                    }}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <TextField
                    label="Email ID :"
                    name="emailId"
                    size="small"
                    value={formData.emailId}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <TextField
                    label="Course Fees"
                    name="fees"
                    size="small"
                    value={formData.fees}
                    // onInput={(e) => {
                    //   let inputValue = e.target.value.replace(/\D/g, "");
                    //   inputValue = inputValue.slice(0, 10);
                    //   e.target.value = inputValue;
                    // }}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={0}
                  px={0}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Installment / Loan available for course?
                  </Typography>

                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    sx={{ flexDirection: "row", gap: 1 }}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        installmentAvailable: e.target.value === "true",
                      }))
                    }
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "14px" },
                          }}
                        >
                          Yes
                        </Typography>
                      }
                      checked={
                        formData.installmentAvailable == "true" ||
                        formData.installmentAvailable == true
                      }
                      className="mulish"
                      // onClick={gender}
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      checked={
                        formData.installmentAvailable == false ||
                        formData.installmentAvailable == "false"
                      }
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "14px" },
                          }}
                        >
                          No
                        </Typography>
                      }
                      className="mulish"
                      // onClick={gender}
                    />
                  </RadioGroup>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={0}
                  px={2}
                >
                  <FormLabel className="mulish">
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Lecture Mode <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </FormLabel>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.offlineLecture}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              offlineLecture: e.target.checked,
                            }))
                          }
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Offline
                        </Typography>
                      }
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.onlineLecture}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              onlineLecture: e.target.checked,
                            }))
                          }
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Online
                        </Typography>
                      }
                    />
                  </FormGroup>
                </Box>
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <TextField
                    label="Course Time"
                    name="courseTiming"
                    size="small"
                    value={formData.courseTiming}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <TextField
                    label="Course City"
                    name="courseCity"
                    size="small"
                    value={formData.courseCity}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <TextField
                    label="Course Area"
                    name="area"
                    size="small"
                    value={formData.area}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <TextField
                    label="Address"
                    name="address"
                    size="small"
                    value={formData.address}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",
                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={0}
                  px={6}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      color: "#01008B",
                    }}
                  >
                    Intership Provided?
                  </Typography>

                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    sx={{ flexDirection: "row", gap: 1 }}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        internshipProvided: e.target.value === "true",
                      }))
                    }
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "14px" },
                          }}
                        >
                          Yes
                        </Typography>
                      }
                      checked={
                        formData.internshipProvided == "true" ||
                        formData.internshipProvided == true
                      }
                      className="mulish"
                      // onClick={gender}
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      checked={
                        formData.internshipProvided == "false" ||
                        formData.internshipProvided == false
                      }
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "14px" },
                          }}
                        >
                          No
                        </Typography>
                      }
                      className="mulish"
                      // onClick={gender}
                    />
                  </RadioGroup>
                </Box>
              </Grid>
            </Grid>

            <Divider
              sx={{
                borderColor: "#4E4E4E",
                borderBottomWidth: 1,
                marginTop: 2,
                marginBottom: 1,
              }}
            />
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="submit"
                sx={{ width: { sm: "70%", xs: "100%" } }}
                variant="contained"
                // sx={{
                //   backgroundColor: "#3695B6",
                //   padding: "14px",
                //   fontSize: "16px",
                // }}
              >
                {modalData ? "Update" : "Save"}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Box>
    </Modal>
  );
}
